export const BffGenericErrorCode = {
  UNKNOWN: 'UNKNOWN',
};
